import { store } from "../core/store";
import { GameState } from "../../shared/types";

export function mountAnnouncement(container: HTMLElement): () => void {
  const wrap = document.createElement("div");
  wrap.className = "announcement-wrap";

  function render(): void {
    const state = store.getState();
    const snapshot = state.snapshot;
    wrap.innerHTML = "";
    if (!snapshot) return;

    const heading = document.createElement("h2");
    const body = document.createElement("div");
    body.className = "announcement-body";

    const artist = snapshot.players.find((p) => p.id === snapshot.currentArtistId);

    switch (snapshot.state) {
      case GameState.ROUND_START:
        heading.textContent = `Round ${snapshot.round} of ${snapshot.totalRounds}`;
        body.textContent = "Get ready...";
        break;
      case GameState.ARTIST_SELECTION:
        heading.textContent = artist ? `${artist.name} is drawing next!` : "Choosing the next artist...";
        break;
      case GameState.NEXT_ARTIST:
        heading.textContent = "Moving on...";
        break;
      case GameState.SCORE_CALCULATION: {
        heading.textContent = "Turn results";
        const result = snapshot.lastTurnResult;
        if (result) {
          const wordLine = document.createElement("p");
          wordLine.innerHTML = `The word was <strong>${escapeHtml(result.word)}</strong> (${result.difficulty})`;
          body.appendChild(wordLine);

          const grid = document.createElement("div");
          grid.className = "turn-result-grid";

          const artistPlayer = snapshot.players.find((p) => p.id === result.artistId);
          grid.appendChild(
            buildResultCard(artistPlayer?.name ?? "The artist", artistPlayer?.color ?? "var(--accent)", result.artistPoints, "🎨 artist")
          );

          for (const guess of result.guessers) {
            const player = snapshot.players.find((p) => p.id === guess.playerId);
            grid.appendChild(
              buildResultCard(player?.name ?? "Someone", player?.color ?? "var(--accent)", guess.points, `#${guess.rank} guess`)
            );
          }
          body.appendChild(grid);

          if (result.guessers.length === 0) {
            const none = document.createElement("p");
            none.className = "hint-text";
            none.textContent = "Nobody guessed it this time.";
            body.appendChild(none);
          }
        }
        break;
      }
      default:
        heading.textContent = "...";
    }

    wrap.append(heading, body);
  }

  render();
  // Everything shown here comes from the snapshot, so the store's other
  // updates (every chat message, word view, ...) needn't rebuild it.
  let renderedSnapshot = store.getState().snapshot;
  const unsub = store.subscribe((state) => {
    if (state.snapshot === renderedSnapshot) return;
    renderedSnapshot = state.snapshot;
    render();
  });
  container.appendChild(wrap);
  return () => unsub();
}

function buildResultCard(name: string, color: string, points: number, tag: string): HTMLElement {
  const card = document.createElement("div");
  card.className = "turn-result-card";
  card.style.borderColor = color;
  card.innerHTML = `
    <span class="turn-result-name" style="color:${color}">${escapeHtml(name)}</span>
    <span class="turn-result-tag">${escapeHtml(tag)}</span>
    <span class="turn-result-points">+${points}</span>
  `;
  return card;
}

function escapeHtml(value: string): string {
  const div = document.createElement("div");
  div.textContent = value;
  return div.innerHTML;
}
